import { useEffect } from "react";
import { CLINIC } from "@/data/site";

// Lightweight SEO/head manager without extra deps.
export default function SEO({ title, description, path = "/", type = "website" }) {
  useEffect(() => {
    const fullTitle = title || `${CLINIC.clinicName} | Obstetrician & Gynaecologist in Noida`;
    const desc =
      description ||
      "Dr. Mithee's Clinic for Women in Noida provides compassionate obstetric and gynaecological care backed by 25+ years of experience. Book a consultation.";
    document.title = fullTitle;

    const setMeta = (attr, key, content) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:type", type);
    setMeta("property", "og:site_name", CLINIC.clinicName);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", window.location.origin + path);
  }, [title, description, path, type]);

  return null;
}
